import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: `}{`[Optional]`}{` Topology in-depth`}</h2>
    <img {...{
      "src": "./../images/demo/image.070.png",
      "alt": "image"
    }}></img>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Find the resource which displays resource name “mysql”. Then, right-click and select `}<strong parentName="p">{`Open in Topology Viewer.`}</strong>{` `}</p>
      <p parentName="blockquote"><strong parentName="p">{`*Result`}</strong>{`: Topology Viewer displays.*`}</p>
    </blockquote>
    <img {...{
      "src": "./../images/demo/image.071.png",
      "alt": "image"
    }}></img>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{`The interface shows the topology surrounding the mysql resource. I can see that the `}<strong parentName="p">{`mysql`}</strong>{` deployment is being called by the `}<strong parentName="p">{`ratings`}</strong>{` service and that it runs on a certain worker node. `}</p>
    <img {...{
      "src": "./../images/demo/image.072.png",
      "alt": "image"
    }}></img>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Change the number of hops to `}<inlineCode parentName="p">{`4`}</inlineCode>{` and click `}<strong parentName="p">{`Render`}</strong>{`.** `}</p>
      <p parentName="blockquote"><strong parentName="p">{`*Result`}</strong>{`: Topology Viewer refreshes with bigger topology.*`}</p>
    </blockquote>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{` I can also increase the size of the graph, still based on the `}<strong parentName="p">{`mysql`}</strong>{` deployment.`}</p>
    <img {...{
      "src": "./../images/demo/image.073.png",
      "alt": "image"
    }}></img>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Right-click om mysql and select `}<strong parentName="p">{`Show last change in timeline`}</strong>{` and check `}<strong parentName="p">{`Delta`}</strong></p>
      <p parentName="blockquote"><strong parentName="p">{`*Result`}</strong>{`: Topology Viewer refreshes and shows the events over time.*`}</p>
    </blockquote>
    <img {...{
      "src": "./../images/demo/image.074.png",
      "alt": "image"
    }}></img>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{` Now I will examine the historical events for the `}<strong parentName="p">{`mysql`}</strong>{` component. I can see the `}<strong parentName="p">{`Alerts`}</strong>{` that have been raised on the `}<strong parentName="p">{`mysql`}</strong>{` resource over time.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      